import MailSocials from "./MailSocials";
import ContactOverlay from "./ContactOverlay";

const Connect = () => {
  return (
    <section className="contact">
      <div className="connect__heading text-R-normal">connect</div>
      <div className="connect__message-group">
        <h2>want to work together?</h2>
        <div className="connect__message text-R-large">
          Feel free to reach out for collaborations or just a friendly hello
        </div>
      </div>
      <MailSocials />
      <ContactOverlay />
    </section>
  );
};

export default Connect;
